export enum SizesEnum {
	XS = "xsmall",
	SM = "small",
	UNDER_MD = "under-medium",
	MD = "medium",
	LG = "large",
	XL = "xlarge"
}
